import { FunctionComponent } from 'preact';
import { Book } from '@novelizing/types';
import { useInfiniteScroll } from '../../hooks';
import { BooksGrid } from '../BooksGrid';
import './LatestBooks.css';

async function fetchLatestBooks(offset: number, limit: number) {
  const response = await fetch(
    `/api/v0/fictions/latest?count=${limit}&offset=${offset}`,
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch books: ${response.status} ${response.statusText}`,
    );
  }

  const data = await response.json();

  return {
    data: data.fictions,
    total: data.metadata.total,
    count: data.fictions.length,
  };
}

interface LatestBooksProps {
  limit?: number;
}

export const LatestBooks: FunctionComponent<LatestBooksProps> = ({
  limit = 16,
}) => {
  const {
    data: books,
    loading,
    error,
    hasMore,
    lastElementRef: lastBookElementRef,
  } = useInfiniteScroll<Book>(fetchLatestBooks, { limit });

  return (
    <div className="latest-books-container">
      {error && <div className="error-message">{error}</div>}

      <BooksGrid books={books} lastBookElementRef={lastBookElementRef} />

      {loading && (
        <div className="loading-indicator">Loading more books...</div>
      )}
      {!hasMore && books.length > 0 && (
        <div className="end-message">No more books to load</div>
      )}
      {!loading && books.length === 0 && !error && (
        <div className="empty-message">No moe books</div>
      )}
    </div>
  );
};
